<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper flex-center">
                <div v-if="modalType !== 'handler'" class="modal-container" :class="[{'save-modal-container': modalType === 'save-modal' || modalType === 'create-pdf-modal'}, {'result-wheel-container': modalType === 'result-wheel-modal'}]">
                    <button type="button" @click="closeModal()" class="close-button">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>
                    <div class="modal-body">
                        <slot name="body">
                            <component :is="modalType" :data="data"></component>
                        </slot>
                    </div>
                </div>
                <div v-else class="modal-container big">
                    <h4 class="text-center">{{modalData}}</h4>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loginModal from './login-modal'
import editProjectModal from './edit-project-modal'
import saveModal from './save-modal'
import sdgInfoModal from './sdg-info-modal'
import removeTaskModal from './remove-task-modal'
import resultWheelModal from './result-wheel-modal'
import historyWheelModal from './history-wheel-modal'
import createPdfModal from './create-pdf-modal'
import removeProjectModal from './remove-project-modal'

export default {
  name: 'modal',
  data () {
    return {
      data: null
    }
  },
  components: {
    'login-modal': loginModal,
    'edit-project-modal': editProjectModal,
    'save-modal': saveModal,
    'sdg-info-modal': sdgInfoModal,
    'remove-task-modal': removeTaskModal,
    'result-wheel-modal': resultWheelModal,
    'historyWheelModal': historyWheelModal,
    'create-pdf-modal': createPdfModal,
    'remove-project-modal': removeProjectModal
  },
  computed: {
    ...mapGetters({
      modalType: 'getModalType',
      modalData: 'getModalData'
    })
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData'
    }),
    closeModal () {
      this.setShowModal(false)
      this.setModalType(null)
      this.setModalData(null)
    }
  },
  watch: {
    modalType (val) {
      this.data = this.modalData
    }
  }
}
</script>
